<template>
  <v-container fluid class="footer white--text py-16 px-0 footer-wave">
    <svg
      class="footer-bg"
      viewBox="0 0 1440 690"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        class="path-0"
        d="M 0,700 L 0,262 C 295.5,267.5 591,273 831,273 C 1071,273 1255.5,267.5 1440,262 L 1440,700 L 0,700 Z"
        fill="#1B45B1"
      />
    </svg>
   

    <div class="footer-content">
      <v-row class="px-10">
        <v-col
          cols="12"
          lg="6"
          md="6"
          v-for="mMenu in menu.filter((menu) => menu.name === 'Footer')"
          :key="mMenu.id"
        >
          <v-row
            ><v-col
              cols="12"
              lg="6"
              md="6"
              v-for="(item, index) in mMenu.children"
              :key="index"
            >
              <h4 class="mb-7 border-bottom">
                <span>{{ item.text }}</span>
              </h4>
              <ul class="link-items p-lh-m">
                <li v-for="i in item.children" :key="i.id">
                  <v-icon>mdi-chevron-left</v-icon
                  ><a :href="i.link">{{ i.text }}</a>
                </li>
              </ul>
            </v-col></v-row
          >
        </v-col>

        <v-col cols="12" lg="3" md="3">
          <h4 class="mb-7 border-bottom">
            <span> {{ label.menu.contact }}</span>
          </h4>
          <ul class="white--text">
            <li v-if="item.address">
              <v-row class="align-start">
                <v-col cols="12" lg="1" md="1"
                  ><v-icon dark class="p-fs-xxh"
                    >mdi-map-marker-outline</v-icon
                  ></v-col
                >
                <v-col cols="12" lg="11" md="11">
                  <!-- <strong>{{ label.form.address }}</strong> -->
                  <p>
                    {{ item.address }}
                  </p></v-col
                >
              </v-row>
            </li>
            <li v-if="item.tel">
              <v-row class="align-start">
                <v-col cols="12" lg="1" md="1" class="py-0"
                  ><v-icon dark class="p-fs-xxh"
                    >mdi-phone-outline</v-icon
                  ></v-col
                >
                <v-col cols="12" lg="11" md="11" class="py-0">
                  <!-- <strong>{{ label.form.tel }}</strong> -->
                  <p>{{ item.tel }}</p></v-col
                >
              </v-row>
            </li>
            <li v-if="item.email">
              <v-row class="align-start">
                <v-col cols="12" lg="1" md="1"
                  ><v-icon dark class="p-fs-xxh"
                    >mdi-email-outline</v-icon
                  ></v-col
                >
                <v-col cols="12" lg="11" md="11">
                  <!-- <strong>{{ label.form.email }}</strong> -->
                  <p>{{ item.email }}</p></v-col
                >
              </v-row>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" lg="3" md="3">
          <h4 class="mb-7 border-bottom">
            <span> {{ label.menu.subscribe }}</span>
          </h4>
          <p class="white--text">
            با عضویت در خبرنامه میتوانید از آخرین اخبار و رویدادها مطلع  
            شوید.
          </p>
          <v-row class="pa-3">
            <v-col cols="4" class="pa-0">
              <v-btn
                dark
                color="first"
                height="100%"
                width="100%"
                @click="addSubscriber"
                >ثبت عضویت</v-btn
              >
            </v-col>
            <v-col cols="8" class="pa-0">
              <v-text-field
                dark
                type="email"
                outlined
                hide-details
                placeholder="آدرس ایمیل"
                v-model="form.input"
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <a
              v-for="item in socialNetwork"
              :key="item.id"
              class="ma-4 rounded-circle"
              :href="item.link"
            >
              <v-img :src="item.iconAddress" class="icon-btn" contain />
            </a>
          </div>
        </v-col>
      </v-row>
      <v-divider class="bg-p-white my-10"></v-divider>
      <v-row class="text-center pb-5"
        ><v-col cols="12" class="white--text">{{
          item.copyright
        }}</v-col></v-row
      >
    </div>

    <!-- Add Modal -->
    <v-dialog v-model="addModal" max-width="400px" overlay-color="success">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row class="mt-1">
              <v-col cols="12" lg="7" md="7" class="d-flex align-center pl-0">
                <v-text-field
                  label="کد اعتبار سنجی"
                  name="captchaCode"
                  color="first"
                  hide-spin-buttons
                  outlined
                  class="text-center"
                  type="number"
                  v-model="form.captcha"
                  hide-details
                >
                </v-text-field>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      plain
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="reloadCaptcha"
                    >
                      <v-icon id="captchaRefreshTlp">mdi-reload</v-icon>
                    </v-btn>
                  </template>
                  <span>بارگذاری مجدد کپچا</span>
                </v-tooltip>
              </v-col>
              <v-col
                cols="12"
                lg="5"
                md="5"
                class="d-flex align-center justify-center px-1"
              >
                <img
                  :src="captcha.dntCaptchaImgUrl"
                  alt="captcha"
                  class="captcha"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            class="px-4"
            small
            @click="addModal = false"
          >
            {{ label.button.cancel }}
          </v-btn>
          <v-btn
            color="success"
            class="px-3"
            small
            depressed
            :loading="loadingBtn"
            @click="sendNewsLetter"
          >
            <v-icon small class="me-1">
              mdi-checkbox-marked-circle-outline
            </v-icon>
            {{ label.button.submitInfo }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";

export default {
  computed: {
    ...mapGetters({
      item: "operationX/config",
      socialNetwork: "operationX/socialNetwork",
      menu: "operationX/menu",
      loadingBtn: "loadingBtn",
      postCheck: "postCheck",
      captcha: "captcha",
    }),
  },
  data() {
    return {
      alert,
      label,
      form: {
        input: null,
        captcha: null,
      },
      addModal: false,
    };
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadFields();
        this.reloadCaptcha();
      }
    },
  },
  methods: {
    addSubscriber() {
      if (this.form.input != null && this.form.input !== "") {
        this.addModal = true;
        this.reloadCaptcha();
      } else {
        this.$store.commit("setError", alert.error.emptyFields);
      }
    },
    sendNewsLetter() {
      let formData = new FormData();
      if (this.form.input != null && this.form.input !== "") {
        formData.append("Input", this.form.input);
        if (this.form.captcha && this.form.captcha.length > 0) {
          formData.append("CaptchaInputText", this.form.captcha);
          formData.append("CaptchaText", this.captcha.dntCaptchaTextValue);
          formData.append("CaptchaToken", this.captcha.dntCaptchaTokenValue);
          this.$store.dispatch("operationX/sendNewsLetter", formData);
        } else {
          this.$store.commit("setError", alert.error.captcha);
        }
      } else {
        this.$store.commit("setError", alert.error.emptyFields);
      }
    },
    reloadCaptcha() {
      this.$store.dispatch("getClientCaptcha");
      this.form.captcha = null;
    },
    reloadFields() {
      this.form = {
        input: null,
        captcha: null,
      };
      this.addModal = false;
    },
  },
  beforeCreate() {
    this.$store.dispatch("operationX/getSocialNetwork");
    this.$store.dispatch("operationX/getMenu");
  },
};
</script>



